import {RadioGroup as RadixRadioGroup, RadioGroupItem} from '@radix-ui/react-radio-group';
import React from 'react';

import {twx} from '@/utils/tailwindUtils';

const SettingsRadioGroup = ({options, value, onValueChange, className, isDisabled, onDisableClick}) => {
    return (
        <RadixRadioGroup
            value={value}
            onValueChange={isDisabled ? onDisableClick : onValueChange}
            className={twx('flex w-full flex-col rounded-xl ml:bg-primary-dark-5 ml:p-4', className)}
        >
            {options.map((option, index) => {
                const isActive = value === option.value;
                const showAsDisabled = isDisabled && !isActive;

                return (
                    <React.Fragment key={option.value}>
                        <div className='flex items-center justify-start gap-2'>
                            <label className='flex flex-1 items-center gap-2' htmlFor={option.value}>
                                <span className={twx('h-12 w-12 shrink-0', showAsDisabled && 'opacity-60')}>
                                    {option.icon}
                                </span>
                                <span
                                    className={twx(
                                        'text-start text-16 font-bold',
                                        showAsDisabled && 'text-primary-dark-85'
                                    )}
                                >
                                    {option.label}
                                </span>
                            </label>
                            <RadioGroupItem
                                value={option.value}
                                id={option.value}
                                className={twx(
                                    'relative ml-2 h-6 w-6 rounded-full border border-primary-dark focus:outline-none focus:ring-2',
                                    showAsDisabled && 'opacity-60',
                                    isActive &&
                                        'after:absolute after:left-1/2 after:top-1/2 after:block after:h-3 after:w-3 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:bg-primary-dark after:content-[""]'
                                )}
                            >
                                <span className='sr-only'>{option.ariaLabel}</span>
                            </RadioGroupItem>
                        </div>
                        {index < options.length - 1 && <hr className='my-4 border-t border-primary-dark-15' />}
                    </React.Fragment>
                );
            })}
        </RadixRadioGroup>
    );
};

export default SettingsRadioGroup;
